module.exports = __webpack_public_path__ + "img/type_box_city.6b2faee7.jpg";